export function normalizeSuggestions(result) {
  return result.map((element) => ({ name: element }));
}
